import type { ReactNode } from 'react';
import { BrandPanel } from './Login';
import { BRAND } from '@dru/types';

/**
 * The frame the sign-in screen uses, for the pages that sit beside it:
 * setting a password from an invitation, and asking for a reset link. Same
 * brand panel, same narrow column, so the link in an email lands somewhere
 * that looks like the product it came from.
 */
export function AuthFrame({ title, lead, children }: {
  title: string;
  lead: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="flex min-h-screen bg-white">
      <BrandPanel />
      <main className="flex min-h-screen w-full flex-col lg:w-[42%] lg:min-w-[440px]">
        <div className="bg-gradient-to-r from-brand-navy to-brand-magenta px-6 py-5 lg:hidden">
          <img
            src={BRAND.logo.full}
            alt={BRAND.logo.alt}
            width={200}
            height={42}
            className="h-[38px] w-auto object-contain brightness-0 invert"
          />
        </div>
        <div className="flex flex-1 items-start justify-center px-6 pb-10 pt-8 sm:px-10 lg:items-center lg:py-10">
          <div className="w-full max-w-[380px] animate-rise-in">
            <header className="mb-7">
              <h1 className="text-h2 text-neutral-900">{title}</h1>
              <p className="mt-1.5 text-small text-neutral-500">{lead}</p>
            </header>
            {children}
          </div>
        </div>
        <footer className="px-6 pb-6 text-center text-micro font-normal text-neutral-500 sm:px-10">
          © {new Date().getFullYear()} {BRAND.longName}
        </footer>
      </main>
    </div>
  );
}
